import React from 'react';
import { StepType } from '../../types/enums';
import Step from '../Step/Step';
import { useStandaloneDynamicOptions } from '@de/hooks/useStandaloneDynamicOptions';
import type { Step as StepT } from '../../types/types';

interface StepContentProps {
  step: StepT;
  stepType?: string;
}

export const StepContent: React.FC<StepContentProps> = ({ step, stepType }) => {
  const {
    options,
    searchBarAllOptions,
    isOptionsLoading,
    dynamicOptionsError,
  } = useStandaloneDynamicOptions(step);

  if (stepType !== StepType.QUESTION && stepType !== StepType.MULTI_QUESTION) {
    return null;
  }

  return (
    <Step
      {...(step as any)}
      {...(options !== undefined && { options })}
      {...(searchBarAllOptions !== undefined && { searchBarAllOptions })}
      isOptionsLoading={isOptionsLoading}
      dynamicOptionsError={dynamicOptionsError}
    />
  );
};
